import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ProfileLabeledInput from "./profile-labeled-input.js";

export default function ProfileSignupForm({
  texts,
  email,
  onChangeEmail,
  password,
  onChangePassword,
  passwordConfirm,
  onChangePasswordConfirm,
  errors,
  champsProfile,
  canSubmit,
  onSubmit,
  onBackToProfile,
}) {
  const emailInputRef = useRef(null);

  useEffect(() => {
    if (emailInputRef.current != null)
      emailInputRef.current.focus();
  }, []);

  const onSignupFieldKeyDown = e => {
    if (e.key === "Enter")
      onSubmit();
  };

  return (
    <div id="profile-page" className="profile-div">
      <div className="display-inline-block">
        <div className="profile-div profile-label-wrapper-title profile-signup-form-title">
          <span className="profile-span">{texts.createCompte}</span>
        </div>
        <ProfileLabeledInput ref={emailInputRef} label={texts.email} value={email} onChange={e => onChangeEmail(e.target.value)} errors={errors.email} onKeyDown={onSignupFieldKeyDown} />
        <ProfileLabeledInput type="password" label={texts.password} value={password} onChange={e => onChangePassword(e.target.value)} errors={errors.password} onKeyDown={onSignupFieldKeyDown} />
        <ProfileLabeledInput type="password" label={texts.confirmPassword} value={passwordConfirm} onChange={e => onChangePasswordConfirm(e.target.value)} errors={errors.passwordConfirm} onKeyDown={onSignupFieldKeyDown} />
        <div className="profile-div profile-separator" />
        {champsProfile}
        {canSubmit && (
          <div className="profile-div">
            <div className="profile-div btn-login clickable" onClick={e => onSubmit()}>
              <span className="profile-span">{texts.confirmNouveauCompte}</span>
            </div>
          </div>
        )}
        <div className="profile-div" style={{ textAlign: "center" }}>
          <span className="clickable primary-color message profile-span" onClick={e => onBackToProfile()}>
            {texts.text2}
          </span>
        </div>
      </div>
    </div>
  );
}

ProfileSignupForm.propTypes = {
  texts: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  passwordConfirm: PropTypes.string.isRequired,
  onChangePasswordConfirm: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  champsProfile: PropTypes.node.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBackToProfile: PropTypes.func.isRequired,
};
